import axios from 'axios';

// 直接使用阿里云API端点
const API_URL = 'https://dashscope.aliyuncs.com/api/v1/';
const APP_ID = '27dc9d32200d4a59ade097778a894605';
const API_KEY = 'sk-c4e0665e71d34746999da6260362d0f4';

// 测试函数，直接调用阿里云API
export const testDirectApi = async (prompt = '你好，我想了解中医养生') => {
  try {
    console.log('直接调用百炼API测试开始');
    
    const url = `${API_URL}applications/${APP_ID}/deployments/default/generation`;
    
    const payload = {
      input: {
        prompt: prompt
      },
      parameters: {
        has_thoughts: false
      }
    };
    
    console.log('直接请求URL:', url);
    console.log('请求参数:', payload);
    
    const response = await axios.post(url, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${API_KEY}`,
      }
    });
    
    console.log('直接调用百炼API响应:', response.data);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('直接调用百炼API错误:', error);
    
    if (error.response) {
      console.error('错误响应:', error.response.data);
      console.error('状态码:', error.response.status);
    }
    
    return {
      success: false,
      error: error.message,
      details: error.response?.data || {}
    };
  }
}; 